export enum RequestType {
  Get = 'get',
  Post = 'post',
}
